import { withTranslation } from 'react-i18next';

import SMSTiersTable from './SMSTiersTable';

export default withTranslation()(SMSTiersTable);
